import showToast from '../components/ToastComponent';
import { createPackSlip } from '../service/createPackSlip';

export const openPackingSlip = async (accessToken: string, orderId: number) => {
  const slipWindow = window.open('', '_blank');
  if (!slipWindow) {
    showToast({
      message: 'Unable to open the packing slip. Please allow pop-ups.',
      type: 'error',
    });
    return;
  }
  slipWindow.document.title = 'Packing Slip';
  slipWindow.document.body.innerText = 'Loading packing slip...';

  const packSlipResult = await createPackSlip(accessToken, orderId);

  if (packSlipResult.status === 200 && packSlipResult.data) {
    slipWindow.location.href = URL.createObjectURL(
      new Blob([packSlipResult.data], { type: 'application/pdf' }),
    );
    return;
  }

  slipWindow.close();
  showToast({
    message: packSlipResult.message ?? 'Unable to download packing slip',
    type: 'error',
  });
};
